import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_14BBlue_14ABlue = () => <CrossRoad coords="1718.000000, 979.000000"/>;

export default CrossRoad_14BBlue_14ABlue;
